const state = {
  users: {},
  user: null,
  processing: false,
  processingUser: false,
};

export default state;
